import React from 'react';
import { Clock, CheckCircle, XCircle } from 'lucide-react';
import { Card } from '../../ui/card';

export default function LeaveStats({ stats }) {
  return (
    <div className="grid grid-cols-3 gap-4">
      <Card className="border-l-4 border-l-amber-500">
        <div className="p-4 flex items-center h-full min-h-[100px]">
          <div className="flex items-center justify-between w-full">
            <div>
              <p className="text-sm text-gray-500">Menunggu</p>
              <p className="text-2xl font-bold">{stats.pending || 0}</p>
            </div>
            <Clock className="w-8 h-8 text-amber-500" />
          </div>
        </div>
      </Card>
      <Card className="border-l-4 border-l-green-500">
        <div className="p-4 flex items-center h-full min-h-[100px]">
          <div className="flex items-center justify-between w-full">
            <div>
              <p className="text-sm text-gray-500">Disetujui</p>
              <p className="text-2xl font-bold">{stats.approved || 0}</p>
            </div>
            <CheckCircle className="w-8 h-8 text-green-500" />
          </div>
        </div>
      </Card>
      <Card className="border-l-4 border-l-red-500">
        <div className="p-4 flex items-center h-full min-h-[100px]">
          <div className="flex items-center justify-between w-full">
            <div>
              <p className="text-sm text-gray-500">Ditolak</p>
              <p className="text-2xl font-bold">{stats.rejected || 0}</p>
            </div>
            <XCircle className="w-8 h-8 text-red-500" />
          </div>
        </div>
      </Card>
    </div>
  );
}
